import React from "react"
import { LayoutPageHeader, LayoutPageContent } from "components"
import { Breadcrumb, Layout } from "antd"
import { useGetAppConfig } from "contexts/configuration/hooks/use-get-app-config"
import { FileTextOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons"
import { Link, useHistory } from "react-router-dom"
import styled from "styled-components"
import { useConfigurationContext } from "contexts/configuration/context"
import {
  useOpusPermissions,
  EOpusPermission
} from "contexts/authorization/hooks/use-opus-permissions"
import ChooseProduct, { IActiveProduct } from "components/ChooseProduct"

const PaddedWrapper = styled.div`
  height: 100%;
  margin: 0 0 15px 0;
  padding: 20px;
  background: #ffffff;
`

export const ChooseQuote: React.FunctionComponent = () => {
  const configuration = useConfigurationContext()
  const { applicationConfig, isLoading } = useGetAppConfig()
  const history = useHistory()

  const { havePermission: isAdmin } = useOpusPermissions(
    EOpusPermission.aventusadmin,
    "true"
  )

  const quoteCoverTypes = (applicationConfig?.activeLinesOfBusiness ?? [])
    .filter(
      (activeLine) =>
        activeLine.isActive && (activeLine.audience !== "Broker" || isAdmin)
    )
    .map((activeLine) =>
      activeLine.coverTypes.map((coverType) => ({
        ...coverType,
        label: coverType.underwriter
          ? `${coverType.label} (${coverType.underwriter})`
          : coverType.label,
        id: activeLine.id,
        isActive: activeLine.isActive,
        productType: activeLine.productType,
        audience: activeLine.audience
      }))
    )
    .flat()
    .sort((a, b) => (a?.dashboardOrder ?? 0) - (b?.dashboardOrder ?? 0))

  const customerProducts = quoteCoverTypes.filter(
    (item) => item.audience !== "Broker"
  )
  const brokerProducts = quoteCoverTypes.filter(
    (item) => item.audience === "Broker"
  )

  const handleChooseProduct = (product: IActiveProduct) => {
    let quoteUrl

    if (configuration.flags.platformVersion === "v3") {
      if (
        configuration.products?.[product.productReferenceId]?.newQuoteType ===
        "digitalunderwriting"
      ) {
        quoteUrl = `/symphony/new/${product.id}`
      } else {
        quoteUrl = `/create-quote/${product.productReferenceId}`
      }
    } else {
      if (product.productType === "Hybrid") {
        quoteUrl = `/symphony/new/${product.id}/${product.productReferenceId}`
      } else {
        quoteUrl = `/opus/new/${product.productReferenceId}/${product.name}`
      }
    }

    history.push(quoteUrl)
  }

  return (
    <Layout>
      <LayoutPageHeader
        ghost={false}
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/quotes">
                <FileTextOutlined />
                &nbsp; Quotes
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Choose Quote Product</Breadcrumb.Item>
          </Breadcrumb>
        }
        title="Choose Quote Product"
      />
      <LayoutPageContent style={{ height: "100%" }} transparent={true}>
        <PaddedWrapper>
          <ChooseProduct
            onChooseProduct={handleChooseProduct}
            groups={[
              {
                title: "Customer",
                icon: <UserOutlined />,
                products: customerProducts
              },
              {
                title: "Broker",
                icon: <TeamOutlined />,
                products: brokerProducts
              }
            ]}
            isLoading={isLoading}
          />
        </PaddedWrapper>
      </LayoutPageContent>
    </Layout>
  )
}
